import styled from '@emotion/styled';
import { css } from '@emotion/core';
import { borderRadii, layers } from 'app/spacing';
import { shadow, shadowLight } from 'app/colors';

export const GridWrapper = styled.div`
  & .layout {
    margin-bottom: ${({ rowHeight }) => rowHeight}px;
    z-index: ${layers.content(0)};
    min-height: ${({ minHeight }) => minHeight}px;
  }

  & .react-draggable-dragging {
    // 11 gets us above most things, but the chart legend sits at 90
    z-index: 91;
  }

  ${({ enableTouchActions }) =>
    enableTouchActions
      ? css`
          & .react-grid-item {
            touch-action: revert !important;
          }
        `
      : ''}
`;

export const OverFlowContainer = styled.span`
  overflow: hidden;
`;

export const DashletCard = styled.div`
  ${({ isHTML }) =>
    isHTML
      ? css`
          .dashlet-head {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            padding: 15px;
            padding-top: 11px;
            z-index: 15;
          }
        `
      : css``}

  background-color: ${({ backgroundColor }) =>
    backgroundColor ?? 'var(--color-background-white)'};
  ${({ customStyles }) =>
    customStyles &&
    `border:  ${customStyles?.borderWeight ?? 0}px solid ${customStyles?.borderColor ?? 'var(--color-background-white)'};`};
  border-radius: ${({ customStyles }) =>
    customStyles?.borderRadius ?? borderRadii.small};
  ${({ customStyles }) => (customStyles?.dropShadow ? shadow : '')};
  ${({ hasShadow }) =>
    hasShadow === true
      ? css`
          filter: drop-shadow(0 18px 26px rgba(0, 0, 0, 0.06));
        `
      : ''};
  & .drag-handle {
    opacity: ${({ forceShowUI }) => (forceShowUI ? 1 : 0)};
    transition: opacity 0.1s;
    z-index: 20;
  }
  overflow: hidden;

  & .Resizer {
    opacity: 0;
    transition: opacity 0.1s;
  }

  .react-resizable-handle {
    ${({ customStyles }) =>
      customStyles?.bottomRightBorderRadius &&
      customStyles?.bottomRightBorderRadius > 15
        ? css`
            bottom: 10px;
            right: 10px;
          `
        : ''};
  }

  &:hover .drag-handle,
  &:hover .Resizer {
    opacity: 1;
  }

  & .dashlet-filter {
    transform: scale(0.8);
  }

  & .dashlet-all-controls {
    background-color: transparent;
  }

  & .dashlet-control {
    opacity: ${({ forceShowUI }) => (forceShowUI ? 1 : 0)};
    transition: opacity 0.1s;
  }

  &:hover .dashlet-control {
    opacity: 1;
  }

  &:hover .dashlet-all-controls::before {
    opacity: 1;
  }

  &:hover .dashlet-all-controls {
    background-color: ${({ customStyles, isHTML }) =>
      customStyles?.titleBackgroundColor
        ? customStyles?.titleBackgroundColor
        : isHTML
          ? 'transparent'
          : 'var(--color-background-white)'};
  }

  & .dashlet-all-controls.title-focused * {
    opacity: 0;
    pointer-events: none;
    user-select: none;
  }

  & .dashlet-all-controls.title-focused {
    opacity: 0;
  }

  & .dashlet-always-visible {
    opacity: 1;
  }

  .kds-icon-arrows-rotate {
    opacity: ${({ forceShowUI }) => (forceShowUI ? 1 : 0)};
    transition: opacity 0.1s;
    z-index: 20;
  }

  .react-resizable-handle {
    opacity: ${({ forceShowUI }) => (forceShowUI ? 1 : 0)};
    transition: opacity 0.1s;
    z-index: 20;
    ${({ disableResize }) => disableResize && 'pointer-events: none;'}
  }

  .react-resizable-handle::after {
    border-color: var(--color-background-dark);
  }

  .react-resizable-handle:hover::after {
    border-color: var(--color-border-darker);
  }

  &:hover .react-resizable-handle,
  &:hover .kds-icon-arrows-rotate {
    opacity: ${({ disableResize }) => (disableResize ? 0 : 1)};
  }

  .dashlet-menu {
    opacity: ${({ forceShowUI, alwaysShowMenu }) =>
      forceShowUI || alwaysShowMenu ? 1 : 0};
    transition: opacity 0.1s;
    z-index: 11;
  }

  .dashlet-filter {
    ${({ alwaysShowMenu }) =>
      alwaysShowMenu
        ? css`
            opacity: 1;
          `
        : ''}
  }

  && button.dashlet-menu > i {
    color: var(--color-background-dark);
  }

  && button.dashlet-menu > i:hover {
    color: var(--color-background-darker);
  }

  .dashlet-calendar-menu:hover {
    cursor: pointer;
    color: var(--color-background-darker);
  }

  &:hover .dashlet-menu {
    opacity: 1;
  }
  &:after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 36px; /* matches your padding-top */
    background-color: transparent;
    z-index: ${layers.content(
      0,
      0
    )}; /* must be ABOVE the :before, BELOW the content */
    pointer-events: none; /* so it doesn't block clicks */
  }

  &:before {
    ${({ hasShadow }) => (hasShadow == null ? shadowLight : '')};
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: ${layers.content(0, -1)};
  }
`;

export const FirstDashletCard = styled(DashletCard)`
  border: 1px dashed var(--color-border-dark);
  cursor: pointer;
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const DashboardGridPageContainer = styled.div`
  position: relative;
  z-index: 0;
  ${({ isMobile }) => (isMobile ? 'overflow: hidden;' : '')};

  .react-grid-item.react-grid-placeholder {
    background-color: var(--color-background-hover);
    opacity: 1;
    z-index: ${layers.content(0)};
  }

  .react-grid-item.react-grid-placeholder .react-resizable-handle {
    display: none;
  }
`;

export const DashboardGridContainerBox = styled.div`
  width: 100%;

  .error-container {
    padding-right: 10px;
    padding-left: 0;
  }
`;
